import { emptyRule, mergeRule } from './ruleSchema';

export function compileRules(configs, providers = []) {
  const map = {};
  if (!Array.isArray(configs) || configs.length === 0) return map;
  if (!Array.isArray(providers) || providers.length === 0) return map;

  for (const config of configs) {
    let merged = emptyRule();
    for (const provider of providers) {
      let partial = null;
      try {
        partial = provider(config, configs);
      } catch (err) {
        console.error('[FieldEngine] rule provider threw:', err);
        partial = null;
      }
      if (partial) merged = mergeRule(merged, partial);
    }
    map[config.fieldKey] = merged;
  }
  return map;
}

export function applyCompiledRules(configs, ruleMap = {}) {
  if (!Array.isArray(configs)) return [];
  return configs.map(config => {
    const rules = ruleMap[config.fieldKey];
    if (!rules) return config;
    return {
      ...config,
      isNonEditable: rules.isNonEditable ?? config.isNonEditable,
      effects:       [...(config.effects || []),    ...(rules.effects || [])],
      validation:    [...(config.validation || []), ...(rules.validation || [])],
      optionFilter:  rules.optionFilter ?? config.optionFilter,
    };
  });
}